import {LastErrorsWidget, LastOrdersWidget, MixedWidget6, ProductsTileWidget, UsersTileWidget} from "../widgets";
import React from "react";
import {LastInvoicesWidget} from "../widgets/lists/LastInvoicesWidget";

export function BuyerDashboard() {

    return (
        <>
            {/* begin::Dashboard */}

            {/* begin::Row */}
            <div className="row">
                <div className="col-xl-6">
                    <LastInvoicesWidget className="gutter-b" baseColor="primary" widgetHeight="150px"/>
                </div>
                <div className="col-lg-6">
                    <LastOrdersWidget className="card-stretch gutter-b"/>
                </div>
            </div>

        </>
    )
}